import { all, takeLatest, call, put } from "redux-saga/effects";
import actions from "./actions";
import { getBannerContentData } from "../../services/contentApi";

function* getBannerContentDataCall() {
  try {
    const response = yield call(getBannerContentData);
    const { data: { data } } = response;

    if (data) {
      yield put(actions.getBannerContentDataSuccess(data));
    } else {
      yield put(actions.getBannerContentDataFailed());
    }
  } catch (e) {
    yield put(actions.getBannerContentDataFailed());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_BANNER_CONTENT_DATA_START, getBannerContentDataCall),
  ]);
}
